import NodeLayer, { questionTypes, narrativeSplitPoint } from './NodeLayer';
import Handlebars from 'handlebars';
import Scene from './Scene';
import { QAResponse } from '../service/FileService';

export default class NarrativeBuilder {
  private _currentNode: NodeLayer;
  private _narrative = '';
  private _scene: Scene;
  private _qaResponses: QAResponse[] = [];

  constructor(scene: Scene, private _answerMap?: any) {
    this._currentNode = scene.startLayer;
    this._scene = scene;
  }

  getAnswerForNode(layer: NodeLayer): string {
    if (this._answerMap == null) {
      return layer.answer;
    }

    if (layer.answers.length != 0) {
      return layer.answer;
    }

    let saved = this._answerMap[layer.id];

    if (saved == null || saved.length == 0) {
      return '';
    }

    return saved[0];
  }

  getAnswerForCurrentNode(): string {
    return this.getAnswerForNode(this._currentNode);
  }

  getAnswersForNode(layer: NodeLayer): string[] {
    if (this._answerMap == null) {
      return layer.answers;
    }

    if (layer.answers.length != 0) {
      return layer.answers;
    }

    return this._answerMap[layer.id] || [];
  }
  getFilesNamesForNode(layer: NodeLayer): string[] {
    if (this._answerMap == null) {
      return layer.uploadedFilesNames;
    }

    if (layer.uploadedFilesNames.length != 0) {
      return layer.uploadedFilesNames;
    }

    return this._answerMap[layer.id] || [];
  }

  getAnswersForCurrentNode(): string[] {
    return this.getAnswersForNode(this._currentNode);
  }
  getFilesNamesForCurrentNode(): string[] {
    return this.getFilesNamesForNode(this._currentNode);
  }

  nextNode() {
    for (var conn of this._currentNode.outgoingConnections) {
      if (
        conn.condition == '' ||
        conn.condition
          .split(narrativeSplitPoint)
          .includes(this.getAnswerForCurrentNode())
      ) {
        this._currentNode = conn.endNode;

        return;
      }
    }

    this._currentNode = null;
  }

  getAnswersString(): string {
    let answers = this.getAnswersForCurrentNode();
    if (answers.length == 1) {
      return answers[0];
    }

    var template =
      '{{#each this}}{{#if @last}} and {{this}}{{else if @first}}{{this}}{{else}}, {{this}}{{/if}}{{/each}}';
    var delegate = Handlebars.compile(template);

    return delegate(answers);
  }

  buildNarrativeForCurrentNode(): string {
    var nar = unescape(
      this._currentNode.templateDelegate({ value: this.getAnswersString() })
    );

    if (nar.length == 0) {
      return '';
    }

    let answers = this.getAnswersForCurrentNode();

    if (this._currentNode.questionType == questionTypes.yesNo) {
      var split = nar.split(narrativeSplitPoint);
      if (answers[0] == 'Yes') {
        return split[0][split[0].length - 1] != '.' ? `${split[0]}.` : split[0];
      } else {
        return split[1][split[1].length - 1] != '.' ? `${split[1]}.` : split[1];
      }
    }

    return nar[nar.length - 1] != '.' ? `${nar}.` : nar;
  }

  buildNarrative() {
    this._currentNode = this._scene.startLayer;

    while (true) {
      if (this._currentNode == null) {
        return {
          narrative: this._narrative,
          responses: this._qaResponses,
        };
      }

      let answers = this.getAnswersForCurrentNode();
      let filesNames = this.getFilesNamesForCurrentNode();

      this._narrative = `${
        this._narrative
      } ${this.buildNarrativeForCurrentNode()}`;

      this._qaResponses.push({
        q: this._currentNode.questionText,
        a: answers ? answers.join(',') : '',
        filesNames,
      });

      var l = this._narrative.length;
      if (
        this._narrative.charAt(l - 1) == '.' &&
        this._narrative.charAt(l - 2) == '.'
      ) {
        this._narrative = this._narrative.slice(0, -1);
      }
      this.nextNode();
    }
  }
}
